import { Component, AfterViewInit, ViewChild, ChangeDetectorRef } from '@angular/core';
import { HttpService } from 'src/app/http.service';
import { TableComponent } from '../table/table.component';

@Component({
  selector: 'app-front-category',
  templateUrl: './front-category.component.html',
  styleUrls: ['./front-category.component.scss']
})
export class FrontCategoryComponent implements AfterViewInit {

  public company_uuid;
  @ViewChild("table", { static: false }) tb: TableComponent;

  constructor(private http: HttpService, private cdr : ChangeDetectorRef) {
    this.http.getSelectedCompany().subscribe(val => {
      this.company_uuid = val;
    });
   }

   ngAfterViewInit(): void {
    this.init();
  }

  async init() {
    const setting = 
        { post: {url: "/admin/app/category", data: {uuid: this.company_uuid}},
          disabled_pagenat: true,
          fields: [
            {label: 'No', type: 'index'}, 
            {label: 'Title', type: 'string', key: 'title'}, 
            {label: 'Sort', type: 'string', key: 'sort'},
            {label: 'Status', type: 'status', key: 'status'},
            {label: 'Hide from Menu', type: 'yesno', key: 'hide_from_menu'},
            {label: 'View', type: 'link', key: 'uuid', 'link': '/lo' + (this.company_uuid ? '/' + this.company_uuid : '/null') + "/front/category/form", hide: true},
            {label: 'Delete', type: 'delete', key: 'uuid', table: 'setting_game_category', title: 'title', hide: true},
          ]}
      this.tb.init(setting);
      this.cdr.detectChanges();
  }

}
